import { Injectable } from '@angular/core';
import { GlobalErrorHandlerService } from '../shared/services/global-error-handler.service';
import { HttpRequestService } from '../shared/services/http-request.service';
import { NotificationService } from '../shared/services/notification.service';
import { Observable, catchError, throwError, tap } from 'rxjs';
import { ENDPOINTS } from '../shared/constants/url.constants';
import { formatUrl } from '../shared/utils/format-url-util';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {
  constructor(
    private http: HttpRequestService,
    private notificationService: NotificationService,
    private errorHandler: GlobalErrorHandlerService
  ) {}

  getDropdownDetails(programCode: string, participantId: any): Observable<any> {
    const url = formatUrl(ENDPOINTS.AUTHORIZATION.GET_WEEKLY_LIMIT_VALUES, {
      programCode,
      participantId,
    });
    return this.http.get(url).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  getWeeklyLimitHistory(programCode: string, payload: any): Observable<any> {
    const url = formatUrl(ENDPOINTS.AUTHORIZATION.GET_WEEKLY_LIMIT_HISTORY, {
      programCode,
    });
    return this.http.post(url, payload, true).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  saveWeeklyLimit(data: any, programCode: string, readReplica = false) {
    const url = formatUrl(ENDPOINTS.AUTHORIZATION.SAVE_WEEKLY_LIMIT, {
      programCode,
    });
    return this.http.post(url, data, readReplica).pipe(
      tap(() => {
        this.notificationService.success('Success', 'Added Successfully');
      }),
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  updateWeeklyLimit(data: any, programCode: string) {
    const url = formatUrl(ENDPOINTS.AUTHORIZATION.SAVE_WEEKLY_LIMIT, {
      programCode,
    });
    return this.http.patch(url, data).pipe(
      tap(() => {
        this.notificationService.success('Success', 'Updated Successfully');
      }),
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  deleteWeeklyLimit(programCode: string, id: any): Observable<any> {
      const url = formatUrl(ENDPOINTS.AUTHORIZATION.DELETE_WEEKLY_LIMIT, { programCode, id });
      return this.http.delete(url).pipe(
        tap(() => {
          this.notificationService.success(
            'Success',
            'Deleted Successfully'
          );
        }),
        catchError((err) => {
          return throwError(() => this.errorHandler.handleError(err));
        })
      );
  }
}
